const BRANDCOLORS = {
  mos: [
    "#f7f8ee",
    "#e7ebc9",
    "#dbe1af",
    "#cbd38a",
    "#c1ca73",
    "#b1bd50",
    "#a1ac49",
    "#7e8639",
    "#61682c",
    "#4a4f22"
  ],
  purple: [
    "#f7f4f9",
    "#e6dceb",
    "#dacbe1",
    "#c9b4d3",
    "#bfa5cb",
    "#af8fbe",
    "#9f82ad",
    "#786387",
    "#604f69",
    "#4a3c50"
  ],
  pink: [
    "#faebf3",
    "#eec0d9",
    "#e6a2c7",
    "#da77ae",
    "#d35d9e",
    "#c83486",
    "#b62f7a",
    "#8e255f",
    "#6e1d4a",
    "#541638"
  ],
  blue: [
    "#e9f1f7",
    "#c1d6e9",
    "#a8c1d8",
    "#85a4c5",
    "#5e7da2",
    "#4a6283",
    "#38475c",
    "#293648",
    "#212f3e",
    "#1f2937"
  ],
  indigo: [
    "#e9eff4",
    "#bccede",
    "#9cb6ce",
    "#6e94b8",
    "#5280aa",
    "#276095",
    "#235788",
    "#1c446a",
    "#153552",
    "#10283f"
  ],
  cyan: [
    "#F0F9FE",
    "#CFEBFB",
    "#B8E2F9",
    "#98D4F6",
    "#84CCF4",
    "#65BFF1",
    "#5caedb",
    "#4888ab",
    "#386985",
    "#2a5065"
  ],
  yellow: [
    "#fcf6e8",
    "#f6e3b8",
    "#f2d696",
    "#ecc366",
    "#e9b748",
    "#e3a51a",
    "#cf9618",
    "#a17512",
    "#7d5b0e",
    "#5f450b"
  ],
  green: [
    "#e8f2e8",
    "#b9d5b9",
    "#97c197",
    "#68a568",
    "#4a934a",
    "#1d781d",
    "#1a6d1a",
    "#155515",
    "#104210",
    "#0c320c"
  ],
  red: [
    "#faedec",
    "#eec7c4",
    "#e6aba8",
    "#db8580",
    "#d46d68",
    "#c94942",
    "#b7423c",
    "#8f342f",
    "#6f2824",
    "#541f1c"
  ],
  grey: [
    "#fefefe",
    "#fafafa",
    "#f8f8f8",
    "#f5f5f5",
    "#f3f3f3",
    "#f0f0f0",
    "#dadada",
    "#aaaaaa",
    "#848484",
    "#656565"
  ],
  orange: [
    "#fdefe9",
    "#f9cdba",
    "#f7b598",
    "#f39469",
    "#f17f4c",
    "#ed5f1f",
    "#d8561c",
    "#a84316",
    "#823411",
    "#64280d"
  ],
  violet: [
    "#f4e9ef",
    "#dbbbcd",
    "#ca9ab5",
    "#b26c93",
    "#a3507e",
    "#8c245e",
    "#7f2156",
    "#631a43",
    "#4d1434",
    "#3b0f27"
  ],
  black: [
    "#e8e9ea",
    "#b7babd",
    "#95989d",
    "#646a70",
    "#464d55",
    "#18202a",
    "#161d26",
    "#11171e",
    "#0d1217",
    "#0a0d12"
  ],
  brown: [
    "#ece9e6",
    "#c3b9b3",
    "#a7988e",
    "#7e685a",
    "#654b3a",
    "#3f1e09",
    "#391b08",
    "#2d1506",
    "#231105",
    "#231105"
  ],
  white: [
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff",
    "#ffffff"
  ],
  magenta: [
    "#ffeef7",
    "#feb2d7",
    "#fe8fc5",
    "#fd79b9",
    "#fd58a8",
    "#fc0089",
    "#e5007d",
    "#b30061",
    "#8b004b",
    "#6a003a"
  ],
  sunny: [
    "#fffaeb",
    "#ffeec1",
    "#ffe6a3",
    "#ffda78",
    "#ffd35e",
    "#ffc836",
    "#e8b631",
    "#b58e26",
    "#8c6e1e",
    "#6b5417"
  ]
};
export {
  BRANDCOLORS
};
